import { isArray, isDefined, isUndefined } from '../../../utils/isDefined';

const mapFeatures = ({ features, travelData = true }) => {
  if (!isArray(features) || features.length === 0) {
    return [];
  }

  return features.reduce((arr, feature) => {
    switch (feature.key) {
      case 'main-package': {
        if (isUndefined(feature?.featureAttributes)) {
          return arr;
        }

        const attributes = feature?.featureAttributes;

        const refillObject = attributes.find(attr => attr.key === 'mp-refill');

        if (isUndefined(refillObject)) {
          return arr;
        }

        return [
          ...arr,
          {
            label: 'Refill',
            value: checkValue(refillObject.value),
            isBoolean: true
          }
        ];
      }
      case 'watch-esim': {
        if (isUndefined(feature?.featureAttributes)) {
          return arr;
        }

        const attributes = feature?.featureAttributes;

        const enabledObject = attributes.find(attr => attr.key === 'enabled');

        if (isUndefined(enabledObject)) {
          return arr;
        }

        return [
          ...arr,
          {
            label: feature.name,
            value: checkValue(enabledObject.value),
            isBoolean: true
          }
        ];
      }
      case 'addons': {
        let addons = [];
        if (isUndefined(feature?.featureAttributes)) {
          return arr;
        }

        const attributes = feature?.featureAttributes;

        if (travelData) {
          const usaObject = attributes.find(attr => attr.key === 'EU-USA');

          if (isDefined(usaObject)) {
            let value = checkValue(usaObject.value, true);

            addons = [
              ...addons,
              {
                label: usaObject.name,

                value,
                isBoolean: value === false ? true : false
              }
            ];
          }

          const travelObject = attributes.find(
            attr => attr.key === 'travel-data'
          );

          if (isDefined(travelObject)) {
            let value = checkValue(travelObject.value, true);

            addons = [
              ...addons,
              {
                label: travelObject.name,
                value,
                isBoolean: value === false ? true : false
              }
            ];
          }
        }

        const extraSimObject = attributes.find(attr => attr.key === 'EXTRASIM');

        if (isDefined(extraSimObject)) {
          let value = checkValue(extraSimObject.value, true);

          addons = [
            ...addons,
            {
              label: extraSimObject.name,
              value,
              isBoolean: value === false ? true : false
            }
          ];
        }

        return [...arr, ...addons];
      }
      default:
        return arr;
    }
  }, []);
};

export default mapFeatures;

const checkValue = (value, showValue) => {
  if (isUndefined(value) || value === false || value === 'DISABLED_OPTION') {
    return false;
  }

  return showValue ? value : true;
};
